export default __webpack_public_path__ + "static/media/landscape19.3d4bf184.jpg";